import type {
  ApiItem,
  Category,
  SubCategory
} from './HierarchicalMultiSelect.types';

const transformCategories = (data: ApiItem[]): Category[] => {
  const alertSubcategories: SubCategory[] = [];
  const auditSubcategories: SubCategory[] = [];

  data.forEach((item) => {
    const isAudit = item.name.startsWith('audit_');

    const subCategory: SubCategory = {
      id: item.name,
      label: item.name,
      category: isAudit ? 'Audit Reports API' : 'Alert Center API',
      type: 'subcategory'
    };

    if (isAudit) {
      auditSubcategories.push(subCategory);
    } else {
      alertSubcategories.push(subCategory);
    }
  });

  const result: Category[] = [];

  if (alertSubcategories.length > 0) {
    result.push({
      id: 'alertapi',
      label: 'Alert Center API',
      type: 'category',
      subcategories: alertSubcategories
    });
  }

  if (auditSubcategories.length > 0) {
    result.push({
      id: 'auditreports',
      label: 'Audit Reports API',
      type: 'category',
      subcategories: auditSubcategories
    });
  }

  return result;
};
export default transformCategories;
